import { mapActions } from "vuex";
import { words } from "lodash";
import getCheckPhone from '@/common/js/checkPhone.js';

export default {
    name: "archivme",
    data() {
        // 手机号校验
    const checkPhone = getCheckPhone();
        return {
            permissions: {
				ReceiptAddressBookAdd: false,        //新增地址
                ReceiptAddressBookBatchDelete: false,//批量删除
                ReceiptAddressBookUpdate: false,     //编辑
                ReceiptAddressBookDelete: false,     //删除
                ReceiptAddressBookQuery: false       //查询
			},
            title:'',
            addAddressVisible: false,
            creating: false,
            form2: {
                province: "",
                district: "",
                addrDetail: "",
                cityName: "",
                cityCode: "",
                coordinate: "",
                contacts: "",
                phone: "",
				addrType: "2",
                rules: {
                    contacts: [
                        { required: true, message: "请输入联系人", trigger: "blur" },
                    ],
                    phone: [
                        { required: true, trigger: "blur", validator: checkPhone },
                    ],
                    addrDetail: [
                        { required: true, message: "请选择地址", trigger: "change" },
                    ],
                },
            },
            SFMap: window.SFMap,
            mapVisible: false,
            map: {
                markerTpl: null,
                mapIns: null,
                vectorLayer: null,
                markersList: [],
                currVo: null,
                poiset: [],
                inputCityName: '深圳市',
                keyWord: '',
                province: '',
                district: '',
                cityCode: '',
                addrDetail: '',
                cityName: '',
                coordinateLon: null,
                coordinateLat: null,
            },
            pageLoading: false,
            deleteDialogVisible: false,
            updateDialogVisible: false,
            currentRow: null,
            currId:null,
            addressPageData: [],
            addressPageInitInfo: {
                pageSizes: [10, 20, 30, 40, 50, 100],
                pageSize: 10,
                pageNumber: 1,
                total: 0
            },
            form: {
                province: null,
                cityName: null,
                district: null,
                contacts: null,
                pageNum: null,
                pageSize: null
            },
            cityNameList: [
            ],
            areaList: [
            ],
            details: {
                waybillNum: null,
                comment: null
            },
            receiptStates: [
                {
                    value: '5',
                    label: '全部'
                },
                {
                    value: '1',
                    label: '待寄回'
                },
                {
                    value: '2',
                    label: '待签收'
                },
                {
                    value: '3',
                    label: '已签收'
                },
                {
                    value: '4',
                    label: '无法寄回'
                }

            ],
            tableColunm: [// 列表
                {
                    prop: 'contacts',
                    label: '联系人',
                }, {
                    prop: 'phone',
                    label: '手机号',
                },{
                    prop: 'address',
                    label: '地址',
                    width: 450
                }
            ],
            multipleSelection: [],
            localCityCache: [],
            provinceList: [],
            cityList: [],

        }
    },
    methods: {
        ...mapActions([
            "getAddrInformationCfg",
            "deleteAddrInformationCfg",
            "deleteAllAddrInformationCfg",
            "queryCitys",
            'addAddressApi',
            'queryAddrByCoordinateApi',
            'queryAddrByKeywordApi',
        ]),
        onOpenAddAddresss() {
            this.$refs.newAddressFormRef.resetFields();
        },
        oncloseAddAddresss() {
            this.$refs.newAddressFormRef.resetFields();
        },
        onAddAddressconfirm() {
            let params = Object.assign({}, this.form2)
            params.address = params.addrDetail
            delete params.addrDetail
            delete params.rules

            this.$refs.newAddressFormRef.validate((valid) => {
                if (valid) {
                    let msg = ''
                    if(this.title == '新增地址'){
                        msg = '新增成功'
                    }else{
                        msg = '修改成功'
                        params.id = this.currId
                    }
                    this.addAddressApi(params).then(res => {
                        this.$message({
                            type: 'success',
                            message: msg
                        });
                        this.addAddressVisible = false;
                        this.getPagaData();
                    }).catch(() => { })
                }
            })
        },
        emapopen(obj) {
            let nodelist = document.querySelectorAll(".el-autocomplete-suggestion.el-popper");
            for (let i = 0; i < nodelist.length; i++) {
                nodelist[i].style.display = "none";
            }
        },
        onOpenMap(obj) {
            this.mapVisible = true;
            this.map.currVo = obj
        },
        eMapOpened() {
            this.$refs.keywordRef.focus();
            if (!this.map.mapIns) {
                this.map.mapIns = this.SFMap.map("map", {
                    center: [22.524729, 113.940159],
                    zoom: 15
                });
                this.map.vectorLayer = this.SFMap.vectorLayer({ map: this.map.mapIns });
                this.map.mapIns.on("click", this.onMapClick);
            }
        },
        eMapClosed() {
            this.map.coordinate = ''
            this.map.keyWord = ''
            if (this.map.markerTpl) {
                this.map.vectorLayer.removeLayer(this.map.markerTpl);
            }
            this.removeMarkersList();
        },
        onMapClick(e) {
            this.map.coordinateLat = e.latlng.lat.toFixed(6);
            this.map.coordinateLon = e.latlng.lng.toFixed(6);
            let coordinate = this.map.coordinateLon + ',' + this.map.coordinateLat
            this.$message({
                type: 'info',
                message: '查询中...'
                , duration: 1000
            });
            if (this.map.markerTpl) {
                this.map.vectorLayer.removeLayer(this.map.markerTpl);
            }
            this.map.markerTpl = this.SFMap.marker([this.map.coordinateLat, this.map.coordinateLon]);
            this.map.vectorLayer.addLayer(this.map.markerTpl);
            this.queryAddrByCoordinateApi({ coordinate: coordinate }).then(res => {
                this.fillMapInfo(res.name, res.city, res.regcode, coordinate, res.province, res.district)
            })
        },
        fillMapInfo(addrDetail, cityName, cityCode, coordinate, province, district) {
            this.map.cityName = cityName;
            this.map.addrDetail = addrDetail;
            this.map.cityCode = cityCode;
            this.map.coordinate = coordinate;
            this.map.inputCityName = cityName;
            this.map.keyWord = addrDetail;

            this.map.province = province;
            this.map.district = district;
        },
        addMarker(arr) {
            let layer = this.map.vectorLayer;
            arr.forEach((item, index) => {
                let address = item.name;
                let addrDetail = item.adname + item.shortName
                let province = ''
                let o = item.lnglat.split(',')
                let coord = [o[1], o[0]]
                if (index == 0) {
                    this.moveMap(coord)
                }
                if (item.adname.indexOf('省') > 0) {
                    province = item.adname.split('省')[0] + '省'
                } else {
                    province = ''
                }
                let iconMarker = this.SFMap.marker(coord, {
                    iconIndex: index + 1
                }).on("click", () => {
                    this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
                }).bindTooltip(address);
                layer.addLayer(iconMarker);
                this.map.markersList.push(iconMarker);
            });
        },
        removeMarkersList() {
            if (this.map.markersList && this.map.markersList.length > 0) {
                for (let i = 0; i < this.map.markersList.length; i++) {
                    this.map.vectorLayer.removeLayer(this.map.markersList[i]);
                }
                this.map.markersList = [];
            }
        },
        moveMap(coord) {
            this.map.mapIns.panTo(coord);
        },
        onhandleCommand(item) {
            let addrDetail = item.adname + item.shortName
            let o = item.lnglat.split(',')
            let coord = [o[1], o[0]]
            let province = ''
            if (item.adname.indexOf('省') > 0) {
                province = item.adname.split('省')[0]
            } else {
                province = ''
            }
            this.fillMapInfo(addrDetail, item.cityName, item.regcode, item.lnglat, province, item.area);
            this.moveMap(coord)
        },
        queryTipByKeyword(cb) {
            let params = {
                'cityName': this.map.inputCityName,
                'keyWord': this.map.keyWord,
                noFailMsg: true
            }
            // !this.map.inputCityName || 
            if (!this.map.keyWord) {
                this.$message({
                    type: 'warning',
                    message: '请输入城市和地址关键字！'
                });
                this.searchList = []
                return cb(this.searchList)
            }
            this.$refs.keywordRef.activated = true
            this.queryAddrByKeywordApi(params).then(res => {
                const poiset = (res || {}).poiset || []
                this.searchList = poiset.map(ele => {
                return {
                    ...ele,
                    value: ele.name
                }
                })
                cb(this.searchList)
                this.map.poiset = poiset
                this.addMarker(poiset);
                if (!this.searchList.length) {
                    this.$message({
                        type: 'warning',
                        message: '地址不存在，请重试输入地址'
                    });
                }
            })
        },
        onSearchAddr(querystring, cb) {
            if (!querystring) {
                this.searchList = []
                return cb(this.searchList)
            }

            if (this.map.markerTpl) {
                this.map.vectorLayer.removeLayer(this.map.markerTpl);
            }
            if (this.map.keyWord.indexOf('市') > -1) {
                this.map.inputCityName = this.map.keyWord.split('市')[0]
            } else {
                this.map.inputCityName = ''
            }
            this.queryTipByKeyword(cb);
            this.removeMarkersList();
        },
        onAddrconfirm() {
            if (this.map.keyWord && this.searchList && this.searchList.length === 1) {
                this.onhandleCommand(this.searchList[0])
            }

            if (!this.map.keyWord || !this.map.coordinate) {
                this.$message({
                    type: 'warning',
                    message: '请输入关键字搜索，再选取地址！'
                });
                return;
            }
            this.map.currVo.addrDetail = this.map.addrDetail
            this.map.currVo.cityCode = this.map.cityCode
            this.map.currVo.cityName = this.map.cityName
            this.map.currVo.coordinate = this.map.coordinate

            this.map.currVo.province = this.map.province
            this.map.currVo.district = this.map.district

            this.mapVisible = false;
        },
        receiptSign() {
            this.recpDialogVisible = false;
        },
        //司机无法寄回
        receiptUnableBack() {
            this.recpDialogVisible = false;

        },
        reset() {
            this.form.receiptState = null;
            this.form.orderId = null;
            this.form.orderState = null;
            this.form.waybillNum = null;
            this.form.planDepartTmScope = null;
            this.form.srcCityName = null;
            this.form.destCityName = null;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        rowDblclick(row) {
        },
        // 每页展示多少条数据改变事件
        sizeChange(val) {
            this.addressPageInitInfo.pageSize = val;
            this.addressPageInitInfo.pageNumber = 1;
            this.getPagaData();
        },
        currentChange(val) {
            // alert(val)
            this.addressPageInitInfo.pageNumber = val;
            this.getPagaData();
        },
        queryAddrPage() {
            this.addressPageInitInfo.pageNumber =1;
            this.getPagaData();
        },
        getPagaData() {
			let param = JSON.parse(JSON.stringify(this.form));
			param.addrType = 2
            param.pageSize = this.addressPageInitInfo.pageSize
            param.pageNum = this.addressPageInitInfo.pageNumber
            if (this.form.province) {
                param.province = this.getUtil(this.provinceList, this.form.province);
                if (this.form.cityName) {
                    param.cityName = this.getUtil(this.cityList, this.form.cityName);
                    if (this.form.district) {
                        param.district = this.getUtil(this.areaList, this.form.district);
                    }
                }
            }
            this.getAddrInformationCfg(param).then(res => {
                this.addressPageData = res.rows;
                this.addressPageInitInfo.total = res.totalCount;

            }).catch(e => {});
        },
        queryReceipt() {

        },
        handleClose(row) {

        },
        deleteRow(row) {
            let param = { "id": row.id }
            this.$confirm('确认删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteAddrInformationCfg(param).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功',
                    });
                    this.queryAddrPage();
                }).catch(e => {

                });

            }).catch(() => {

            });

        }, updateRow(row) {
            this.form2.addrDetail = row.address
            this.form2.cityName = row.cityName
            this.form2.cityCode = row.cityCode
            this.form2.coordinate = row.coordinate
            this.form2.contacts = row.contacts
            this.form2.phone = row.phone
            this.currId = row.id
            this.title = '修改地址'
            this.addAddressVisible = true
            this.currentRow = null;
        }, deleteClic_1() {
            //取消删除
            this.deleteDialogVisible = false;
            this.currentRow = null;
        }, deleteClic_2() {
            let param = this.currentRow;
            // 请求后台

            //删除成功
            this.deleteDialogVisible = false;
            this.currentRow = null;
        }, addClic_1() {
            this.updateDialogVisible = false;
            this.currentRow = null;
        }, addClic_2() {
            // this.updateDialogVisible=false;
            this.currentRow = null;
        }, deleteChicked(rows) {
            let multipleSelection = this.multipleSelection;
            let param = { "idList": [] };
            if (multipleSelection.length == 0) {
                this.$message({
                    type: 'error',
                    message: '请选择需要删除的行'
                });
                return;
            }
            for (let i = 0; i < multipleSelection.length; i++) {
                param.idList.push(multipleSelection[i].id)
            }
            this.$confirm('确认删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteAllAddrInformationCfg(param).then(res => {
                    this.$notify({
                        type: 'success',
                        title: '提示',
                        dangerouslyUseHTMLString: true,
                        message: '删除成功',
                        duration: 5000
                    });
                    this.queryAddrPage();
                }).catch(e => {

                });

            }).catch(() => {

            });
        }, resetAddressParam() {
            this.form.province = null;
            this.form.cityName = null;
            this.form.district = null;
            this.form.contacts = null;
        }, addNewAddress() {
            this.title = '新增地址'
            this.addAddressVisible = true

        }, exit() {
            this.currentRow = null
        }, loadCache() {
            let param;
            this.queryCitys(param).then(res => {
                this.localCityCache = res;
                this.provinceList = [];
                for (let i = 0; i < this.localCityCache.length; i++) {
                    let temp = { value: this.localCityCache[i].code, label: this.localCityCache[i].name }
                    this.provinceList.push(temp)// 初始化省
                }

            }).catch(e => {

            });
        }, initCity() {
            let province = this.form.province;
            let localCityCache = this.localCityCache;
			this.form.cityName = null;
			this.form.district = null;
            this.cityList = [];
			this.areaList = [];
            for (let j = 0; j < localCityCache.length; j++) {
                if (localCityCache[j].code == province) {
                    this.cityList = this.initUtil(localCityCache[j].childCity)
                }
            }
        }, initArea() {
            let province = this.form.province;
            let localCityCache = this.localCityCache;
            let cityName = this.form.cityName;
            this.areaList = [];
			this.form.district = null;
            for (let j = 0; j < localCityCache.length; j++) {
                if (localCityCache[j].code == province) {
                    for (let t = 0; t < localCityCache[j].childCity.length; t++) {
                        if (localCityCache[j].childCity[t].code == cityName) {
                            this.areaList = this.initUtil(localCityCache[j].childCity[t].childCity)
                        }
                    }
                }
            }
        }, initUtil(array) {
            let tempArr = [];
            for (let i = 0; i < array.length; i++) {
                let temp = { value: array[i].code, label: array[i].name }
                tempArr.push(temp)
            }
            return tempArr;
        }, getUtil(array, value) {
            let label = null;
            for (let i = 0; i < array.length; i++) {
                if (array[i].value == value) {
                    return array[i].label
                }
            }
            return label;
        }
    },
    mounted: function () {
        this.loadCache();
        this.getPagaData();
    },
    created: function () {
      // this.loadCity();
      this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
    }
}